import React from 'react'
import { indicators } from '../../../../config/paths'


export const CardSummary = ({ title, value, icon }) => {

    return (
        <div className="card">
            <div className="card-body">
                <div className="row mb-2">
                    <div className="col mt-0">
                        <h4 className="fw-bold text-black">{title}</h4>
                    </div>
                    <div className="col-auto">
                        <div className="stat text-primary">
                            <img src={indicators[icon]} className="img-fluid" width={28} alt="tool" />
                        </div>
                    </div>
                </div>
                <div className='text-center'>
                    <h1 className="mt-1 mb-1 text-muted fw-bold"> {Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' }).format(value)}</h1>
                </div>
            </div>
        </div>
    )
}
